import { render, staticRenderFns } from "./LiveBandwidth.vue?vue&type=template&id=0d83269c&scoped=true"
import script from "./LiveBandwidth.vue?vue&type=script&lang=js"
export * from "./LiveBandwidth.vue?vue&type=script&lang=js"
import style0 from "./LiveBandwidth.vue?vue&type=style&index=0&id=0d83269c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83269c",
  null
  
)

export default component.exports